import { render, staticRenderFns } from "./MessageContainer.vue?vue&type=template&id=9685dcd8&scoped=true"
import script from "./MessageContainer.vue?vue&type=script&lang=js"
export * from "./MessageContainer.vue?vue&type=script&lang=js"
import style0 from "./MessageContainer.vue?vue&type=style&index=0&id=9685dcd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9685dcd8",
  null
  
)

/* custom blocks */
import block0 from "./MessageContainer.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports